/**
 * Regras de resolução multi-tenant a partir do hostname.
 *
 * Fonte da verdade pra quais subdomínios viram slug de restaurante e quais ficam
 * reservados pra uso de plataforma/ambiente. Deve ser mantido em sincronia manual
 * com lecartte-server/apps/server/src/utils/reservedSubdomains.ts — drift entre os
 * dois repos é bug em produção.
 */

export const PLATFORM_DOMAINS = ['lecartte.com.br', 'lecartte.com', 'localhost', '127.0.0.1'] as const;

export const RESERVED_SUBDOMAINS: ReadonlySet<string> = new Set([
  'www',
  'admin',
  'console',
  'api',
  'staging',
  'staging-admin',
  'staging-console',
  'staging-server',
  'staging-api'
]);

function stripKnownSuffix(hostname: string): string | null {
  if (hostname.endsWith('.localhost')) return hostname.slice(0, -'.localhost'.length);
  if (hostname.endsWith('.lecartte.com.br')) return hostname.slice(0, -'.lecartte.com.br'.length);
  if (hostname.endsWith('.lecartte.com')) return hostname.slice(0, -'.lecartte.com'.length);
  return null;
}

export function extractSubdomainSlug(hostname: string): string | null {
  const raw = stripKnownSuffix(hostname);
  if (!raw) return null;
  if (RESERVED_SUBDOMAINS.has(raw)) return null;
  return raw;
}

export function isTenantHostname(hostname: string): boolean {
  if ((PLATFORM_DOMAINS as readonly string[]).includes(hostname)) return false;
  const raw = stripKnownSuffix(hostname);
  if (raw && RESERVED_SUBDOMAINS.has(raw)) return false;
  return true;
}

export function isReservedSubdomain(slug: string): boolean {
  return RESERVED_SUBDOMAINS.has(slug);
}
